import React, { useState } from 'react';
// Modal
import CategoryFormModal from '../../../layouts/Modals/CategoryFormModal';

const CategoriesCreate = () => {
  const [ show, setShow ] = useState(false);
  return (
    <>
      <div className="form-group text-right">
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={() => setShow(true)}
        >Create</button>
      </div>
      {/* Modal */}
      {show &&
        <CategoryFormModal
          show={show}
          onHide={() => setShow(false)}
        />
      }
    </>
  )
}

export default CategoriesCreate;
